// frontend/src/components/grid/productFields.js
//
// The wire's row fields a Product cell or a product (group) row is read by, and
// how a grouped grid's product row is told apart.

// A product (header) row, as the backend marks it. The pinned totals row is
// NOT one — it carries no `child_count` — so an editable rule that only asks
// this still has to go through utils/pinnedTotals.js.
export const isProductGroupRow = (data) => data.child_count != null;

export const PRODUCT_FIELD_DEFAULTS = {
  imageField: 'image_url',
  nameField: 'item_name',
  skuField: 'sku',
  codeField: 'item_code',
};

// The row field every grouped grid groups by; also the colId of the hidden
// group column (productGrouping.jsx) and the key `useSsrmGrid.buildSsrmUrl`
// sends as `group_by`.
export const PRODUCT_GROUP_FIELD = 'shopify_product_gid';
// What a product row is called on screen, and its picture: the product's
// featured image, which every grouped endpoint puts on the header row under
// this name (api.filters.product_group_headers, reporting.rowsource).
export const PRODUCT_TITLE_FIELD = 'shopify_product_title';
export const PRODUCT_IMAGE_FIELD = 'image_url';
